import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

import { LANGUAGES_OPTIONS } from '../ChangeLanguage/constants';

import styles from './LanguageSelect.module.scss';
import { Option } from './Option/Option';
import { Placeholder } from './Placeholder/Placeholder';
import { SingleValue } from './SingleValue/SingleValue';
import type { LanguageOption } from './types';

type Props = {
  value: LanguageOption | null;
  onChange: (value: LanguageOption | null) => void;
  disabled?: boolean;
  name?: string;
  hideDropdownArrow?: boolean;
  customStyles?: {
    languageName?: React.CSSProperties;
    singleValue?: React.CSSProperties;
    icon?: React.CSSProperties;
    option?: React.CSSProperties;
    menu?: React.CSSProperties;
    menuList?: React.CSSProperties;
  };
  showShortLanguageCode?: boolean;
  showSingleValuePrefixIcon?: boolean;
  customStylesWrapper?: React.CSSProperties;
  classNames?: {
    wrapper?: string;
  };
  showOverButton?: boolean;
  dataTestId?: string;
  options?: LanguageOption[];
};
export function LanguageSelect(props: Props) {
  const { t } = useTranslation();

  return (
    <>
      <div className={classNames(styles.wrapper, props.classNames?.wrapper)} data-testid={props.dataTestId}>
        <Select
          classNames={{
            container: () => styles.container,
            control: (selectState) =>
              classNames(styles.control, {
                [styles.openMenuControl]: selectState.menuIsOpen && !props.showOverButton,
              }),
            valueContainer: () => styles.valueContainer,
            menu: () => classNames(styles.menu, { [styles.menuOver]: props.showOverButton }),
            menuList: () => classNames(styles.menuList, { [styles.menuListOver]: props.showOverButton }),
          }}
          components={{
            Option,
            SingleValue,
            Placeholder,
            IndicatorSeparator: () => null,
            ...(props.hideDropdownArrow && { DropdownIndicator: () => null }),
          }}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.id}
          isClearable={false}
          isDisabled={props.disabled}
          isSearchable={false}
          name={props.name}
          options={props.options || LANGUAGES_OPTIONS}
          placeholder={t('profile.selectLanguage')}
          showShortLanguageCode={props.showShortLanguageCode}
          showSingleValuePrefixIcon={props.showSingleValuePrefixIcon}
          styles={{
            container: (provided) => ({
              ...provided,
              ...props.customStylesWrapper,
            }),
            menu: (provided) => ({
              ...provided,
              ...props.customStyles?.menu,
            }),
          }}
          value={props.value}
          onChange={(newValue) => props.onChange(newValue as LanguageOption | null)}
          {...(props.customStyles ? { customStyles: props.customStyles } : {})}
        />
      </div>
    </>
  );
}
